import { TenantContext } from '@/components';
import { usersRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { UserKey } from './types';

export const useGetUser = (userId: number) => {
  const { currentSelectedTenant } = useContext(TenantContext);

  return useQuery(
    [...UserKey.BY_ID(userId), currentSelectedTenant],
    () => usersRepo.getUserDetails(userId),
    {
      cacheTime: 1000 * 60 * 5,
    },
  );
};
